import { parseStringPromise } from 'xml2js'
import { firstCharLowerCase, parseBooleans } from 'xml2js/lib/processors'
import { CoE, SoE, EoE, listStartupItemTypes } from '/@/shared/entities/StartupItems'
import { extractCoE, extractSoE, extractEoE } from './extractors'
import { parseIndex } from './processors'
import { convertToArray } from '../utils'

class StartupImporter {
  static async import(xmlData: string) {
    const result = await parseStringPromise(xmlData, {
      tagNameProcessors: [firstCharLowerCase],
      attrNameProcessors: [firstCharLowerCase],
      valueProcessors: [parseBooleans, parseIndex],
      attrValueProcessors: [parseBooleans],
      trim: false,
      explicitArray: false,
    })
    return this.formatStartups(result?.etherCATMailbox)
  }

  static formatStartups(mailbox: any) {
    return Object.entries(mailbox)
      .map(([key, value]: [string, any]) => {
        return convertToArray(value.initCmds.initCmd).map((startup: any) => {
          switch (key) {
            case 'soE':
              return new SoE({ ...extractSoE(startup) })
            case 'coE':
              return new CoE({ ...extractCoE(startup) })
            case 'eoE':
              return new EoE({ ...extractEoE(startup) })
            default:
              throw new Error(`Unknown startup type: ${key}`)
          }
        })
      })
      .flat(1)
  }
}

export default StartupImporter
